import { ProductCardHelper } from '../../../../services/MarppleShop/renderApp/components/cells/ProductCard/ProductCardHelper.ts';
import { VectorEditorConstantS } from '../../../VectorEditor/S/Constant/module/VectorEditorConstantS.js';
import { BpOptionKeyRingConstantS } from '../../../BpOption/KeyRing/S/Constant/module/BpOptionKeyRingConstantS.js';
import { differenceTimeInUnits } from '../../../Util/S/Function/util.js';
import { NessLabsConstantS } from '../Constant/module/NessLabsConstantS.js';
import { go, map, pluck, unique, find } from 'fxjs/es';

export const needTildePrice = ({ maker_type, bp_option_ids }) => {
  return (
    (VectorEditorConstantS.KEYRING_EDITOR === maker_type &&
      bp_option_ids?.includes(BpOptionKeyRingConstantS.FREE_BP_OPTION_ID)) ||
    VectorEditorConstantS.ACRYLIC_FIGURE_EDITOR === maker_type
  );
};

export const getProductSalesInfo = (product) => {
  const {
    sell_start_at: _sell_start_at,
    sell_end_at: _sell_end_at,
    quantity,
    order_count,
    is_quantity_public,
  } = product._?.stores_product;
  const _cur_time = new Date();
  const sell_start_at = _sell_start_at && new Date(_sell_start_at);
  const sell_end_at = _sell_end_at && new Date(_sell_end_at);

  // 기간한정 상품 판단
  const has_period_limit = ProductCardHelper.isPeriodLimited({ sell_end_at });

  // 수량한정 상품 판단
  const has_quantity_limit = ProductCardHelper.isQuantityLimited({ quantity });

  // 수량한정 보일지 말지
  const show_quantity_limit = is_quantity_public && has_quantity_limit;

  // 한정상품이면서 솔드아웃인지 체크
  const is_sold_out = ProductCardHelper.isLimitedQuantitySoldOut({ order_count, quantity });

  // 출시 예정인지 체크
  const is_before_sale = ProductCardHelper.isBeforeSale({ sell_start_at });

  // 기간한정 상품이면서 판매끝인지 체크
  const is_after_sale = ProductCardHelper.isEndedSale({ sell_end_at });

  // 판매중인지 판단
  const is_selling_product = !is_before_sale && !is_after_sale && !is_sold_out;

  // 남은 수량
  const left_count = Math.max(0, quantity - order_count);

  // 시작 or 종료까지 남은 시간
  const remain_time_infos = has_period_limit
    ? differenceTimeInUnits(
        ['day', 'hour', 'minute', 'second', 'millisecond'],
        is_before_sale ? sell_start_at : sell_end_at,
        _cur_time,
        true,
      )
    : null;

  return {
    has_period_limit,
    has_quantity_limit,
    show_quantity_limit,
    is_selling_product,
    is_before_sale,
    is_after_sale,
    is_sold_out,
    sell_start_at,
    sell_end_at,
    quantity,
    order_count,
    left_count,
    remain_time_infos,
  };
};

export const getProductBadge = (product) => {
  const cur_date = new Date();
  const productList = go(
    NessLabsConstantS.PRODUCT_EA_LIST,
    find(({ start_at, end_at }) => {
      return cur_date.getTime() >= start_at.getTime() && cur_date.getTime() < end_at.getTime();
    }),
  );
  const type = productList ? (productList.product_ids.includes(product.id) ? 'ea' : 'release') : 'release';
  return {
    type,
    badge: NessLabsConstantS.NESS_LABS_BADGE[type],
  };
};

export const getLabsProductCateList = async (products, cate_list_id) => {
  return go(
    products,
    pluck('_'),
    pluck('base_product'),
    pluck('_'),
    pluck('cate_list'),
    unique,
    (cate) => {
      return [
        {
          name: '전체',
          id: 'all',
        },
        ...cate,
      ];
    },
    map((cate) => {
      return {
        ...cate,
        selected: cate.id == cate_list_id,
      };
    }),
  );
};
